<template>
  <section id="Event" class="g_section">
    <div class="g_bg_text">
      <KinesisScroll
        tag="img"
        :src="'./static/hd_event.svg'"
        :strength="100"
        type="translate"
        axis="y"
      />
    </div>
    <div class="g_hd_en_wrap">
      <FxText>
        <p class="g_hd_en">EVENT</p>
      </FxText>
    </div>
    <div class="g_hd_ja_wrap">
      <FxText>
        <h2 class="g_hd_ja">イベント</h2>
      </FxText>
    </div>
    <div class="content_body">
      <div class="campaign_item">
        <div class="dates">
          <div class="date">常設</div>
        </div>
        <div class="campaign_window">
          <div class="end">
            <img src="../../assets/img_campaign1.png" alt="" />
          </div>
          <h3>インフォメーション<br />場所：欲しがりの切り株広場</h3>
          <p>
            会場の楽しみ方を<br />
            九条林檎さんとねこますさんがご案内！<br />
            会場を探索する前に<br />
            まずはここで情報を<br />確認しましょう！
          </p>
        </div>
      </div>
      <div class="campaign_item">
        <div class="dates">
          <div class="date">常設</div>
        </div>
        <div class="campaign_window">
          <div class="end">
            <img src="../../assets/img_campaign2.png" alt="" />
          </div>
          <h3>定点生放送<br />場所：大門通りほか</h3>
          <p>
            バーチャルキャスト会場の<br />
            様子を徹底生中継！<br />
            放送の視聴者と<br />
            コミュニケーションして<br />遊びましょう！
          </p>
        </div>
      </div>
      <div class="campaign_item">
        <div class="dates">
          <div class="date">常設</div>
        </div>
        <div class="campaign_window">
          <div class="end">
            <img src="../../assets/img_campaign3.png" alt="" />
          </div>
          <h3>ふっとばシードさん<br />場所：大門通り</h3>
          <p>
            自在にポーズをとってシードさんを<br />
            積み上げていきましょう。<br />
            シードさん大砲を使えば<br />
            周りから妨害も出来ます。<br />
            目指せシードさんマスター！
          </p>
        </div>
      </div>
      <div class="campaign_item">
        <div class="dates">
          <div class="date">4/29</div>
        </div>
        <div class="campaign_window">
          <div class="end">
            <img src="../../assets/img_campaign4.png" alt="" />
          </div>
          <h3>オープニング生放送</h3>
          <p>
            バーチャルキャスト会場での<br />見どころをご紹介！<br />
            豪華ゲストも登場！？
          </p>
        </div>
      </div>
      <div class="campaign_item">
        <div class="dates">
          <div class="date">4/29</div>
          <div class="date">5/10</div>
        </div>
        <div class="campaign_window">
          <div class="end">
            <img src="../../assets/img_campaign5.png" alt="" />
          </div>
          <h3>ショップスタッフ登場</h3>
          <p>
            バーチャルキャスト有志がアイテムの<br />購入や使い方をレクチャーしてくれます。<br />
            頭上のガイドが目印！
          </p>
        </div>
      </div>
      <div class="campaign_item">
        <div class="dates"></div>
        <div class="campaign_window">
          <div class="end">
            <img src="../../assets/img_campaign6.png" alt="" />
          </div>
          <h3>VCフォトアルバム</h3>
          <p>
            #Vケット4 #Vキャス会場<br />
            を入れて会場の様子を画像ツイート！<br />
            エンディング放送で紹介します！
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FxText from "../atoms/FxText";
import { KinesisScroll } from "vue-kinesis";
export default {
  name: "Event",
  components: { KinesisScroll, FxText }
};
</script>

<style scoped>
.content_body {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.dates {
  display: flex;
  margin: 0 0 16px;
  height: 26px;
  width: 100%;
}
.date {
  display: inline-flex;
  border: 1px solid #fff;
  background: rgba(3, 1, 116, 0.2);
  box-sizing: border-box;
  justify-content: center;
  width: 4rem;
  font-weight: 900;
  margin: 0 0.5rem 0 0;
}
.campaign_item {
  margin: 0 0 30px;
}
.campaign_window {
  border: 1px solid #fff;
  box-sizing: border-box;
  text-align: center;
  background: rgba(3, 1, 116, 0.2);
}
.campaign_window .end {
  width: 100%;
  position: relative;
  line-height: 1;
  margin-bottom: 0.5rem;
}
.campaign_window .end:before {
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  content: "";
  display: block;
  position: absolute;
  z-index: 1;
  background: rgba(0, 0, 0, 0.25);
}
.campaign_window .end:after {
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  content: "終了しました";
  font-weight: 900;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 2;
  background: rgba(0, 0, 0, 0.25);
}
.campaign_window h3 {
  font-weight: 900;
  margin: 0.2rem 0 0.1rem;
  line-height: 1.2;
  font-feature-settings: "palt";
}
.campaign_window p {
  margin: 0 0 0.5rem;
  font-size: 0.8rem;
}
.notice {
  text-align: right;
  margin: 0;
}
.notice a {
  color: #fff;
}
@media screen and (max-width: 1110px) {
  .campaign_item {
    width: 31%;
  }
  .campaign_window img {
    width: 100%;
  }
  .campaign_window p {
    font-size: 0.8rem;
  }
}
@media screen and (max-width: 768px) {
  .campaign_item {
    width: 48%;
  }
}
@media screen and (max-width: 578px) {
  .campaign_item {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheEventSection.vue